<template>
  <div class="specialInspectsBind">
    <el-dialog
        v-el-drag-dialog
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        :title="specialInspectsBind.pkid > 0 ? '编辑':'新建'"
        class="customer-edit"
        width="1200px"
        top="10vh"
        @close="$reset('form')">
      <el-form
          ref="form"
          v-loading="contentLoading"
          style="position: relative"
          :model="specialInspectsBind"
          :rules="ruleValidate"
          class="form"
          label-width="120px">
        <el-form-item label="检验类型：">
          <el-radio-group v-model="specialInspectsBind.inspectType">
            <el-radio :label="1">特殊工单</el-radio>
            <el-radio :label="2">变更提醒</el-radio>
            <el-radio :label="3">非标提醒</el-radio>
            <el-radio :label="4">项目检验</el-radio>
            <el-radio :label="5">来料变更提醒</el-radio>
            <el-radio :label="6">客户特殊要求</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-if="specialInspectsBind.inspectType < 6" label="出厂编号：">
          <el-input v-model="specialInspectsBind.pcNo"/>
        </el-form-item>
        <div v-if="specialInspectsBind.inspectType > 4" class="vm-separate">
          <el-form-item v-if="specialInspectsBind.inspectType!==5" label="客户名称：">
            <el-input v-model="specialInspectsBind.customerName"/>
          </el-form-item>
          <el-form-item v-if="specialInspectsBind.inspectType!== 6" label="物料号：">
            <el-input v-model="specialInspectsBind.materialNo"/>
          </el-form-item>
        </div>
        <el-button type="primary" @click="$refs.editSpecialInspects.open(0)"> 新建</el-button>
        <el-table
            v-if="specialInspectsBind.inspectType ===1|| specialInspectsBind.inspectType ===4"
            :data="specialInspectsBind.specialInspectsVOS">
          <el-table-column prop="inspectItem" align="center" label="检验项目"/>
          <el-table-column prop="inspectStandard" align="center" label="检验标准"/>
          <el-table-column prop="note" align="center" label="备注"/>
          <el-table-column label="图片上传" prop="photos">
            <template slot-scope="scope">
              <el-button type="primary" @click="$refs.bindPictureEdit.open(scope.row,scope.$index)">
                上传图片
              </el-button>
            </template>
          </el-table-column>
          <el-table-column
              label="操作"
              align="center"
              class-name="vm-table_operate">
            <template slot-scope="scope">
              <el-button type="danger" @click="oneDelete(scope.$index,scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="vm-separate">
          <el-form-item v-if="specialInspectsBind.inspectType !==1 && specialInspectsBind.inspectType !==4" label="提醒内容：">
            <el-input v-model="specialInspectsBind.changeContent" type="textarea"/>
          </el-form-item>

          <el-form-item v-if="specialInspectsBind.inspectType !==1 && specialInspectsBind.inspectType !==4 && specialInspectsBind.inspectType !==5" label="检验类型：">
            <el-select v-model.trim="specialInspectsBind.storageInspectionType" clearable placeholder="请选择">
              <el-option
                  v-for="item in constant.toSelect(constant.storageInspectionType)"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"/>
            </el-select>
          </el-form-item>
        </div>
      </el-form>
      <span slot="footer">
        <el-button type="info" @click="dialogVisible=false">关闭</el-button>
        <el-button :loading="saveLoading" type="primary" @click="specialInspectsSave">保存</el-button>
      </span>
    </el-dialog>
    <special-inspects-edit ref="editSpecialInspects" @add-success="addSpecialInspects"/>
    <bind-picture-edit ref="bindPictureEdit" @add-picture="addPicture"/>
  </div>
</template>

<script>
  import constant from "../../../util/constant";
  import constants from "../../../util/constants";
  import SpecialInspectsEdit from "@/views/purchase/specialInspectsBind/SpecialInspectsEdit";
  import BindPictureEdit from "@/views/purchase/specialInspectsBind/BindPictureEdit";

  export default {
    name: "SpecialInspectsBindEdit",
    components: {BindPictureEdit, SpecialInspectsEdit},
    data() {
      return {
        constant,
        constants,
        dialogVisible: false,
        contentLoading: false,
        saveLoading: false,
        specialInspectsBind: {
          pkid: 0,
          pcNo: "",
          inspectType: 1,
          storageInspectionType: "",
          inspectStatus: "",
          changeContent: "",
          specialInspectsVOS: [],

        },
        ruleValidate: {},
      };
    },
    methods: {
      open(id) {
        this.specialInspectsBind.pkid = id;
        this.dialogVisible = true;
        if (this.specialInspectsBind.pkid > 0) {
          this.getData();
        }
      },
      getData() {
        this.contentLoading = true;
        this.$http
          .get("basic", `specialInspectsBinds/${this.specialInspectsBind.pkid}`)
          .then(resp => {
            console.log(resp);
            this.specialInspectsBind = resp;
            this.contentLoading = false;
          });
      },
      addPicture(row,index) {
        console.log(index, row);
        this.specialInspectsBind.specialInspectsVOS[index].attachments = row.attachments;
      },
      oneDelete(index, row) {
        this.specialInspectsBind.specialInspectsVOS.splice(index, 1);
      },
      addSpecialInspects(row) {
        console.log(row);
        this.specialInspectsBind.specialInspectsVOS.push(row);
      },
      specialInspectsSave() {
        if(this.specialInspectsBind.inspectType ===5) {
          this.specialInspectsBind.pcNo = this.specialInspectsBind.materialNo;
        }
        this.$refs.form.validate(valid => {
          if (valid) {
            this.saveLoading = true;
            this.$http
              .save("basic", "specialInspectsBinds", this.specialInspectsBind)
              .then(() => {
                this.saveLoading = false;
                this.dialogVisible = false;
                this.$emit("save-success");
                this.$message.success("保存成功");
              })
              .catch(() => {
                this.saveLoading = false;
              });
          }
        });
      },
    },
  };
</script>

<style lang="scss">
  .specialInspectsBind {
    .table {
      width: 100%;
      margin: 2% auto;
      border-top: 1px solid #dddddd;
      border-left: 1px solid #dddddd;

      .tableLabel {
        width: 130px;
        padding: 1%;
        background: #f4f7fa;
        border-bottom: 1px solid #dddddd;
      }

      .tableModel {
        width: 20%;
        padding: 1%;
        border-left: 1px solid #dddddd;
        border-right: 1px solid #dddddd;
        border-bottom: 1px solid #dddddd;
      }
    }
  }

</style>
